<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 18 16"
    :fill="fill"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5274 3.1572L9.00002 3.41066L9.47264 3.15719L13.2438 1.13473L17 3.14916L17 7.2162L9.01309 14.6351L1 7.19189V3.14916L4.75621 1.13473L8.5274 3.1572Z"
      stroke="#006EFF"
      stroke-width="2"
    />
  </svg>
</template>

<script>
import { colors } from "../../constants";

export default {
  props: {
    fill: { type: String, default: 'none' },
    width: { type: [Number, String], default: 19 },
    height: { type: [Number, String], default: 18 },
    color: { type: String, default: colors.iconArinet },
  },
};
</script>
